import { fetchParamsByKey } from './url';

const buildChildAgesObj = (urlParams: Array<string>, counter: number) =>
    urlParams.reduce((acc: any, curr: string) => {
        if (curr.indexOf('child_ages') > -1) {
            const ageTuple = curr.split('=');
            acc[`s[child_ages][${counter}]`] = ageTuple[1];
            counter++;
        }
        return acc;
    }, {});

const getSearchParameters = (propertyType: string = 'hotel') => {
    let counter = 0;
    const urlParams = decodeURIComponent(window.location.search).split('&s');
    const childAges = buildChildAgesObj(urlParams, counter);

    // TODO - change this so it doesn't use fetchParamsByKey
    const args: any = {
        's[adults]': fetchParamsByKey('s[adults]') || '2'
    };
    const startDate = fetchParamsByKey('s[date_from]');
    const endDate = fetchParamsByKey('s[date_to]');

    if (startDate && endDate) {
        args['date_from'] = startDate;
        args['date_to'] = endDate;
    }
    args['property_type'] = propertyType;

    return Object.assign({}, args, childAges);
};

export default getSearchParameters;
